import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../../Utils/firebase";
import { v4 as uuidv4 } from "uuid";

const UploadImageOnFirebase = async (userID, file) => {
    if (!file) {
        return { success: false, message: "No file selected", downloadURL: null };
    }

    // Validate file type (only allow images)
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
        return { success: false, message: "Invalid file type", downloadURL: null };
    }

    // Validate file size (limit: 5MB)
    // const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    // if (file.size > MAX_SIZE) {
    //     return { success: false, message: "File size exceeds 5MB", downloadURL: null };
    // }

    // Generate a unique file name with the correct extension
    const fileExtension = file.name.split(".").pop();
    const uniqueFileName = `${uuidv4()}.${fileExtension}`;
    const storageRef = ref(storage, `invoiceGenerator/users/${userID}/${uniqueFileName}`);

    try {
        // Upload file to Firebase Storage
        const uploadSnapshot = await uploadBytes(storageRef, file);

        // Get the file's download URL
        const downloadURL = await getDownloadURL(uploadSnapshot.ref);
          
        return { success: true, message: "File uploaded successfully", downloadURL };
    } catch (error) {
        console.error("Error uploading file:", error);
        return { success: false, message: "Upload failed", downloadURL: null };
    }
};

export default UploadImageOnFirebase;
